import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import { ROOT_URL } from '../../api/ApiConfig';

export const getTagsByBusinessId = createAsyncThunk(
  'tags/getTagsByBusinessId',
  async (_, { getState, rejectWithValue }) => {
    try {
      const { loginToken } = getState();
      const authToken = loginToken?.response?.token;
      const business_id = loginToken?.response?.user?.business_id;
      

      const response = await axios.get(
        `${ROOT_URL}/ticket/tags/${business_id}`,
        {
          headers: {
            'Authorization': `Bearer ${authToken}`
          }
        }
      );

      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

const initialState = {
  tags: [],
  loading: false,
  error: null
};

const getTagsByBusinessIdSlice = createSlice({
  name: 'getTagsByBusinessId',
  initialState,
  reducers: {
    resetTags: (state) => {
      state.tags = [];
      state.loading = false;
      state.error = null;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(getTagsByBusinessId.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getTagsByBusinessId.fulfilled, (state, action) => {
        state.loading = false;
        state.tags = action.payload.data || [];
      })
      .addCase(getTagsByBusinessId.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  }
});

export const { resetTags } = getTagsByBusinessIdSlice.actions;
export default getTagsByBusinessIdSlice.reducer; 